import React, { useState } from 'react';
import Button from '@hubins/components/Button';
import { useMiddleman } from '@hubins/middleman';
import { useNotificationContext } from '@hubins/components/NotificationContext/NotificationContext';
import { Document } from './index';

type Props = {
  document: Document;
  refetch: () => void;
}

const DeleteDocumentButton = ({ document, refetch }: Props) => {
  const middleman = useMiddleman();


  const { setNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await middleman.promiseDelete(document.deleteLink);
      refetch();
      setNotification({ type: 'success', message: <>Successfully deleted <strong>{document.name}</strong></> });
    } catch (e) {
      setNotification({ type: 'error', message: <>Failed to delete <strong>{document.name}</strong></> });
    }
    setLoading(false);
  };

  return (
    <Button icon="Bin by Streamlinehq" onClick={handleDelete} onlyIcon loading={loading} />
  );
};

export default DeleteDocumentButton;